<template>
  <p v-if="!options.length" class="company-switcher__empty">
    {{ $t('nenhumaempresaencontrada') }}
  </p>
  <ul
    v-else
    :id="listboxId"
    ref="list"
    role="listbox"
    :aria-label="$t('empresas')"
    class="company-switcher__list"
    @mousedown.prevent
  >
    <company-switcher-option
      v-for="(option, index) in options"
      :id="optionId(index)"
      :key="option.value"
      :label="option.label"
      :selected="option.value === currentValue"
      :active="index === activeIndex"
      @mousemove.native="$emit('activate', index)"
      @click.native="$emit('select', option.value)"
    />
  </ul>
</template>

<script>
import CompanySwitcherOption from './Option'
import { companyOptionId } from './company-option-id'

export default {
  name: 'CompanySwitcherOptionList',
  components: { CompanySwitcherOption },
  props: {
    listboxId: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    currentValue: {
      type: String,
      default: null
    },
    activeIndex: {
      type: Number,
      required: true
    }
  },
  watch: {
    activeIndex() {
      this.$nextTick(this.scrollToActive)
    }
  },
  mounted() {
    this.scrollToActive()
  },
  methods: {
    optionId(index) {
      return companyOptionId(this.listboxId, index)
    },
    scrollToActive() {
      const item = this.$refs.list && this.$refs.list.children[this.activeIndex]
      if (item) item.scrollIntoView({ block: 'nearest' })
    }
  }
}
</script>
